var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 351.5 298.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-4{stroke:#cbcbca;}.cls-1,.cls-4{stroke-width:3px;}.cls-1,.cls-6{fill:none;}.cls-7{fill:url(#linear-gradient);}.cls-8,.cls-4{fill:#fff;}.cls-9,.cls-5{fill:#cbcbca;}.cls-10{fill:#2b2d2d;}.cls-11{fill:#5fbcc2;}.cls-2{fill:url(#linear-gradient-8);}.cls-2,.cls-3,.cls-6{stroke-width:2px;}.cls-3{fill:url(#linear-gradient-10);stroke:#e6e6e5;}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-2);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-5);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-11);}.cls-6{stroke:#2b2d2d;stroke-linejoin:round;}.cls-5{stroke:#fff;stroke-width:.75px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 111.4,
    y1: 127.65,
    x2: 201.61,
    y2: 127.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5ebdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 21.65,
    y1: 175.84,
    x2: 106.94,
    y2: 175.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e5a82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#45517a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2c3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 116.32,
    x2: 201.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 305.42,
    y1: 254.42,
    x2: 305.42,
    y2: 124.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 305.42,
    y1: 252.54,
    x2: 305.42,
    y2: 280.66,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 285.31,
    y1: 69.87,
    x2: 325.5,
    y2: 29.69,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 237.07,
    y1: 284.88,
    x2: 351.5,
    y2: 284.88,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 288.49,
    y1: 71.86,
    x2: 321.6,
    y2: 129.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd4d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 61.3,
    y1: 173.7,
    x2: 161.96,
    y2: 274.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fcfadf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#faf0c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9e18d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f7d463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f6ca42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f5c22b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f5be1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5bd18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 21.65,
    y1: 272.23,
    x2: 201.61,
    y2: 272.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2.45,
    y1: 101.55,
    x2: 106.63,
    y2: 86.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd4d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 10.87,
    y1: 114.4,
    x2: 101.09,
    y2: 114.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#5ebdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 58.4,
    y1: 15.02,
    x2: 65.67,
    y2: 7.76,
    gradientTransform: "translate(73.43 -50.65) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 51.37,
    y1: 11.41,
    x2: 61.45,
    y2: 11.41,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 54.19,
    y1: 11.41,
    x2: 58.64,
    y2: 11.41,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 131.43,
    y1: -57.01,
    x2: 268.26,
    y2: 79.83,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.85,45.98H20.58c-10.54,0-19.08,8.54-19.08,19.08v72.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.28,152.14v126.08c0,10.54,8.54,19.08,19.08,19.08H191.9c10.54,0,19.08-8.54,19.08-19.08V78.31c0-10.54-8.54-19.08-19.08-19.08H111.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.4,110.07h81.89c4.6,0,8.33,3.73,8.33,8.33v18.5c0,4.6-3.73,8.33-8.33,8.33H111.4v-35.15h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 21.65,
    y: 158.27,
    width: 85.29,
    height: 35.15,
    rx: 11.76,
    ry: 11.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 116.32,
    y: 158.27,
    width: 85.29,
    height: 35.15,
    rx: 11.76,
    ry: 11.76
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191.27,60.34H111.4v38.9h98.14c.16,0,.28-.13,.28-.28v-18.9c.55-10.52-6.77-19.71-18.55-19.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 291.36,
    y: 124.13,
    width: 28.11,
    height: 130.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 291.36,
    y: 252.54,
    width: 28.12,
    height: 28.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 292.36,
    y: 74.52,
    width: 26.12,
    height: 26.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M317.48,75.52v24.12h-24.12v-24.12h24.12m2-2h-28.12v28.12h28.12v-28.12h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 292.53,
    y1: 74.69,
    x2: 317.83,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 318.3,
    y1: 74.69,
    x2: 293,
    y2: 100
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "319.38 75.91 291.26 75.82 298.66 16.43 312.28 16.47 319.38 75.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M261.91,272.46h64.75c13.71,0,24.84,11.13,24.84,24.84h-114.43c0-13.71,11.13-24.84,24.84-24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.82,126.24h36.92v-56.71h-19.7c-18.63,0-35.07,4.43-33.72,33.72v6.48c0,9.12,7.39,16.51,16.51,16.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 21.65,
    y: 206.46,
    width: 179.96,
    height: 35.15,
    rx: 11.76,
    ry: 11.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.65,
    y: 254.65,
    width: 179.96,
    height: 35.15,
    rx: 11.76,
    ry: 11.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M101.09,46.74H21.64c-10.43,0-18.89,8.54-18.89,19.08v72.77H101.09V46.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.65,86.04H2.95c-.31,0-.56-.25-.56-.56l.22-18.88c-.22-12.12,7.95-19.92,18.92-19.45H100.93v38.62c0,.16-.13,.28-.28,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M22.63,96.82H101s.08,.04,.08,.08v35.07H22.63c-6.49,0-11.76-5.27-11.76-11.76v-11.63c0-6.49,5.27-11.76,11.76-11.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.31,140.4l-2.18-.03c-.48,.09-.94-.23-1.03-.71L56.84,24.5c-.18-.96-1.55-.97-1.74-.01l-22.94,115.75c-.1,.48-.56,.79-1.04,.7h-2.08c-.48-.09-.79-.56-.7-1.04L53.77,11.49c.1-.48,.56-.79,1.04-.7l1.01,.2-.02,.09,.25-.05,.25,.05-.02-.1,1.02-.19c.48-.09,.94,.23,1.03,.71l23.68,127.84c.09,.48-.23,.94-.71,1.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "56.31 11.1 56.06 11.04 56.29 11 56.31 11.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M292.89,116.04v-8.18c0-.92,.74-1.66,1.66-1.66h10.23c.81,0,1.5-.58,1.64-1.38l2.75-16.09c.14-.8,.83-1.38,1.64-1.38h8.45c.92,0,1.66,.74,1.66,1.66v27.03c0,.92-.74,1.66-1.66,1.66h-24.7c-.92,0-1.66-.74-1.66-1.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 305.78,
    cy: 82.28,
    r: 4.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.55,88.56l-2.69,15.43c-.07,.4-.42,.69-.82,.69h-12.06c-.46,0-.84,.38-.84,.84v11.64c0,.3-.24,.53-.53,.53h-3.54c-.29,0-.53-.23-.53-.53v-.61c0-.3,.24-.54,.53-.54h1.98v-12.29c0-.37,.24-.69,.58-.8l8.91-2.78c.25-.08,.46-.28,.54-.54l1.22-3.69c.19-.58-.28-1.16-.88-1.09l-8.85,.98c-.5,.05-.93-.34-.93-.83v-.52c0-.38,.25-.71,.61-.81l11.42-3.1c.27-.07,.48-.28,.57-.54l.61-1.86c.12-.35,.44-.58,.8-.58h3.07c.51,0,.91,.47,.82,.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 276.2,
    y: 102.81,
    width: 15.62,
    height: 1.46,
    transform: "translate(110.49 351.08) rotate(-75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 280.38,
    y: 110.14,
    width: 5.33,
    height: 7.55,
    rx: 1.03,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 286.36,
    cy: 95.25,
    r: 1.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 287.04,
    y: 93.71,
    width: 3.1,
    height: 2.4,
    rx: 1.07,
    ry: 1.07
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "56.06 11.04 55.81 11.09 55.82 11 56.06 11.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 59.93,
    y: 6.24,
    width: 4.22,
    height: 10.31,
    transform: "translate(50.65 73.43) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 56.41,
    cy: 11.41,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 56.41,
    cy: 11.41,
    r: 2.23
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M326.74,2.59V20.28c0,1.43-1.16,2.59-2.59,2.59H114.29c-.13,0-.26,0-.38-.03l-1.45-.22-44.19-6.72c-1.27-.19-2.21-1.29-2.2-2.58l.02-3.93c0-1.27,.94-2.35,2.19-2.55L110.55,.26l1.73-.24c.12-.02,.23-.02,.35-.02h211.52c1.43,0,2.59,1.16,2.59,2.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under-construction.bffc08dc9abbcc6ae1882e095d8c36b5.svg";
export { ForwardRef as ReactComponent };